import React from 'react';
import {Route} from 'react-router-dom';
import {ROUTES} from '@contentlab/config/routesConstants';
import ContentLabLogin from '@contentlab/views/auth/login';
import ExternalRedirect from '@/components/external-redirect/ExternalRedirect';

const SIGNUP_REDIRECT_URL =
  'https://ltx.studio/solutions/post-production-tools';

function AuthRoutes() {
  return (
    <>
      <Route path={ROUTES.CONTENT_LAB_LOGIN} element={<ContentLabLogin />} />
      <Route
        path={ROUTES.CONTENT_LAB_SIGNUP}
        element={
          <ExternalRedirect url={SIGNUP_REDIRECT_URL} preserveQueryParams />
        }
      />
    </>
  );
}

export default AuthRoutes;
